import Swal from "sweetalert2";
import { ROLE } from "../component/constants/constants";

export const TimerAlert= (message, title, alertType) => {
    Swal.fire({
        icon: alertType,
        title: title,
        text: message,
        showConfirmButton: false,
        timer: 2000,
      });
    return 2000;  
}

export const ConfirmAlert= (message, title, alertType,ConfirmMsg ) => {
    return Swal.fire({
        icon: alertType,
        title: title,
        text: message,
        showCancelButton: true,
        confirmButtonText: ConfirmMsg,
        confirmButtonColor: '#4cb3c7',
        cancelButtonColor: '#f2645a',
      }); 
}

export const InforAlert= (message, title, alertType,ConfirmMsg ) => {
    return Swal.fire({
        icon: alertType,
        title: title,
        text: message,
        showCancelButton: false,
        confirmButtonText: ConfirmMsg,
        confirmButtonColor: '#4cb3c7',
        allowOutsideClick: false
      }); 
}

export default function TimerAlertForPermission(message, title, alertType) {
  Swal.fire({
      icon: alertType,
      title: title,
      text: message,
      showConfirmButton: false,
      timer: 2000,
    });
  return 2000;  
}

// SIngle component in Roles

export const getRoles = (userInfo) => {
  if (userInfo.RoleId === ROLE.GROK_ADMIN) {
    return "Grok Admin";
  } else if (userInfo.RoleId === ROLE.STUDENT) {
    return "Student";
  } else if (userInfo.RoleId === ROLE.COMPANY) {
    return "Company";
  } else if (userInfo.RoleId === ROLE.COLLEGE) {
    return "College";
  } else {
    return "Unknown Role";
  }
};